import { colors } from "constants/theme"

type IconProps = {
    style?: any
    type?: string
    disabled?: boolean
}

export default function TeethChild(props: IconProps) {
    let color = colors.white
    let bgcolor = colors.themeSecondColor
    let brcolor = colors.themeSecondColor

    if (props.type === 'CHILD') {
        bgcolor = colors.themeSecondColor
        color = colors.white
        brcolor = colors.themeSecondColor
    } else {
        bgcolor = colors.white
        color = colors.themeSecondColor
        brcolor = colors.themeSecondColor
    }

    if (props.disabled) {
        bgcolor = colors.lightGray
        color = colors.disabledGray
        brcolor = colors.lightGray
    }

    return (
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" fill={`${bgcolor}`} stroke={`${brcolor}`} />
            <g clipPath="url(#clip0_3576_146657)">
                <path fillRule="evenodd" clipRule="evenodd" d="M12.8332 11.5883C13.3524 11.2801 13.9672 11.125 14.6678 11.125C15.3591 11.125 15.9484 11.4742 16.355 11.715C16.6993 11.9205 17.0846 12.1875 17.5011 12.1875C17.9176 12.1875 18.3029 11.9198 18.6472 11.715C19.0545 11.4749 19.6431 11.125 20.3344 11.125C21.0357 11.125 21.6505 11.2801 22.169 11.5883C22.6875 11.8964 23.0707 12.3348 23.342 12.8406C23.8733 13.8294 23.9937 15.1016 23.9207 16.3398C23.8464 17.597 23.5666 18.9117 23.2117 20.055C22.8589 21.189 22.4155 22.2069 21.9863 22.8515C21.4933 23.5903 20.8083 23.9579 20.0823 23.8559C19.4157 23.7624 18.8979 23.2942 18.6387 22.775C18.3617 22.221 18.2335 21.6027 17.9906 21.0339C17.8701 20.7534 17.7547 20.555 17.647 20.4353C17.5337 20.3107 17.465 20.3142 17.3559 20.4353C17.2475 20.555 17.1321 20.7534 17.0116 21.0339C16.7687 21.6027 16.6412 22.221 16.3642 22.775C16.1043 23.2942 15.5865 23.7624 14.9206 23.8559C14.1939 23.9579 13.5089 23.5903 13.0159 22.8515C12.5867 22.2069 12.1433 21.189 11.7905 20.055C11.4356 18.9117 11.1559 17.597 11.0822 16.3405C11.0085 15.1009 11.1289 13.8294 11.6602 12.8406C11.9315 12.3348 12.3147 11.8964 12.8332 11.5883Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_3576_146657">
                    <rect width="17" height="17" fill="white" transform="translate(9 9)" />
                </clipPath>
            </defs>
        </svg>)

    // return (
    //     <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" fill="white" />
    //         <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#1CB99A" />
    //         <path fillRule="evenodd" clipRule="evenodd" d="M16.5985 14.012C17.2216 13.6422 17.9594 13.4561 18.8 13.4561C19.6296 13.4561 20.3368 13.8751 20.8247 14.1641C21.2378 14.4106 21.7002 14.7311 22.2 14.7311C22.6998 14.7311 23.1622 14.4098 23.5753 14.1641C24.0641 13.876 24.7704 13.4561 25.6 13.4561C26.4415 13.4561 27.1793 13.6422 27.8015 14.012C28.4237 14.3817 28.8836 14.9079 29.2091 15.5148C29.8466 16.7014 29.9911 18.228 29.9036 19.7138C29.8143 21.2225 29.4786 22.8001 29.0527 24.172C28.6294 25.5329 28.0973 26.7543 27.5822 27.5278C26.9906 28.4144 26.1687 28.8555 25.2974 28.7331C24.4976 28.6209 23.8762 28.0591 23.5651 27.436C23.2328 26.7713 23.0789 26.0293 22.7874 25.3467C22.6429 25.0101 22.5043 24.7721 22.3751 24.6285C22.2391 24.4789 22.1567 24.4831 22.0258 24.6285C21.8957 24.7721 21.7572 25.0101 21.6127 25.3467C21.3211 26.0293 21.1681 26.7713 20.8358 27.436C20.5238 28.0591 19.9025 28.6209 19.1035 28.7331C18.2314 28.8555 17.4094 28.4144 16.8178 27.5278C16.3027 26.7543 15.7706 25.5329 15.3473 24.172C14.9215 22.8001 14.5857 21.2225 14.4973 19.7146C14.4089 18.2271 14.5534 16.7014 15.1909 15.5148C15.5165 14.9079 15.9763 14.3817 16.5985 14.012Z" fill="#1CB99A" />
    //     </svg>)

}
